import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import * as throttle from "lodash/throttle"
import * as classNames from "classnames"
import { HamburgerMenuItems } from "../../../calcalistWidgets/categoryHeader/components/hamburgerMenuList/menuList";
import { toggleSpotImPopUp } from "../../../article/componentas/articleSocialShare1280Component/articleSocialShareNew1280";
import { HeaderScrolledMenu } from "./headerScrolledMenu";

interface MenuState {
    isOpened: boolean
    isSticky: boolean
    isFontMenuOpen: boolean
    fixed: boolean

}
interface HeaderProps {
    groupsWithItems: Group[]
    logoData: Logo
    ynetSearchPageLink: string
    linkToFb: string
    linkToInst: string
    linkToWhatsapp: string
    isArticle: boolean
    layout?: string
    domain: string
    followUsText: string
    flashLinkTarget: LinkTargetProperties
}
export interface Group {
    groupId: string
    groupName: string
    items: HamburgerMenuItems[]
}
export interface Logo {
    url: string
    mediaTitle: string
    link: string
    linkTarget: LinkTargetProperties
}


export class SiteMagazineHeaderMutamComponenta extends React.Component<HeaderProps, MenuState> {
    public static siteScriptName = "SiteMagazineHeaderMutamComponenta";
     private scrollPosition: number = 0;
    constructor(props) {
        super(props)
        this.state = {
            isOpened: false,
            isSticky: false,
            isFontMenuOpen: false,
            fixed: false
        }
    }
    private toggleMenu = (isOpened:boolean) => {
        this.setState({ isOpened: isOpened })
        if(isOpened){
               this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.top = `-${this.scrollPosition}px`;
            document.body.style.width = "100%";
        }
        else{
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            window.scrollTo(0, this.scrollPosition);
        }
    }
    //

    private stickyBar() {
        let element = document.getElementById('ArticleBodyComponent');
        const headerContainerPos = document.querySelector(".magazines-header").getBoundingClientRect().top;
        const headerPos = document.querySelector("#MagazineHeaderMutam").getBoundingClientRect().top;
        let isSticky = element ? headerContainerPos + 40 < 0 : headerPos + 40 < 0;

        if (isSticky) {
            this.setState({ isSticky: true });


        } else {
            this.setState({ isSticky: false })
        }

        let winScroll = document.body.scrollTop || document.documentElement.scrollTop;


        if (element) {
            let headerElRect = document.querySelector(".ArticleHeaderMobileComponent") && document.querySelector(".ArticleHeaderMobileComponent").getBoundingClientRect();
            if (!headerElRect) {
                return
            }
            let scrolled = (winScroll / (element.offsetTop + element.offsetHeight - headerElRect.height)) * 100;
            if (scrolled < 100) {
                document.getElementById("progress-bar").style.width = scrolled + "%";

            } else {
                document.getElementById("progress-bar").style.width = "100%";
            }
        }
    }

    componentDidMount() {
        document.addEventListener("scroll", this.throttledScrollHandler())
        this.props.isArticle && this.setfontSize();
    }
    private setfontSize = () => {
        if (localStorage && localStorage.fontSize) {
            let size = localStorage.fontSize;
            document.documentElement.style.fontSize = size * parseInt(getComputedStyle(document.documentElement).fontSize) + "px";
        }

    }


    componentWillUnmount() {
        document.removeEventListener("scroll", this.throttledScrollHandler())
            if (this.state.isOpened) {
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            // Restore scroll position
            window.scrollTo(0, this.scrollPosition);
        }

    }
    private throttledScrollHandler = () => throttle(() => this.stickyBar(), 200)

    render() {
        const { groupsWithItems, logoData, followUsText, ynetSearchPageLink, linkToFb, linkToInst, layout, domain, linkToWhatsapp } = this.props
       

       return (
                <div className={classNames("MagazineHeaderMutam")} id="MagazineHeaderMutam" >
                    <div className="topAreaHeader">
                    <button className={`menuHamburger ${this.state.isOpened ? "openedMenu" : ""}`} onClick={()=>this.toggleMenu(!this.state.isOpened)} />
                   
                            <HyperLinkBuilder className={`logo`} href={logoData.link} linkTarget={logoData.linkTarget} ariaLabel={logoData.mediaTitle}>
                                <img  aria-label="Page Logo" title={logoData.mediaTitle} alt={logoData.mediaTitle} src={logoData.url} />
                            </HyperLinkBuilder>


                    </div>

               <HeaderScrolledMenu
                        groupsWithItems={groupsWithItems}
                        isVisible={this.state.isOpened}
                        ynetSearchPageLink={ynetSearchPageLink}
                        linkToFb={linkToFb}
                        linkToInst={linkToInst}
                        linkToWhatsapp={linkToWhatsapp}
                        followUsText={followUsText}
                        layout={layout}
                        domain={domain}
                    />
                </div>

            )

    }
}